import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { ReactComponent as NibllLogoSVG } from '../assets/nibll-logo.svg';

import './nibll-logo.scss';

export interface NibllLogoProps extends HTMLAttributes<HTMLElement> {}

export const NibllLogo: FC<NibllLogoProps> = ({ className, ...props }) => (
  <div className={classNames('nibll-logo inline-block h-6 md:h-8 w-auto', className)} {...props}>
    <NibllLogoSVG className="h-full" />
  </div>
);
